// 异样处理页面
import NoAuthority from '_src/pages/exception/NoAuthority'
import NoFound from '_src/pages/exception/NoFound'
import ServerError from '_src/pages/exception/ServerError'

// 路由路径
import Home from '_src/pages/home/home'
import Order from '_src/pages/order/order'
import OrderDetail from '_src/pages/order/detail'
import GoodList from '_src/pages/goods'
import GoodDetail from '_src/pages/goods/detail'
import GoodLog from '_src/pages/goods/log'
import EditGoods from '_src/pages/goods/edit'

import Discount from '_src/pages/discount/list'

import UserList from '_src/pages/user/userList'

import UserDetail from '_src/pages/user/detail'

import ReturnForm from '_src/pages/order/returnForm'
import ReturnDetail from '_src/pages/order/returnDetail'

import RefundOrder from '_src/pages/order/refundOrder'

import MerchantList from '_src/pages/merchant/merchantList'

import MerchantType from '_src/pages/merchant/merchantType'

import AddMerchant from '_src/pages/merchant/addMerchant'

import MerchantDetail from '_src/pages/merchant/merchantDetail'

// 财务管理开始
import Merchants from '_src/pages/finance/merchants/merchants'
import Recharge from '_src/pages/finance/recharge/recharge'
import RechargeLog from '_src/pages/finance/rechargeLog/rechargeLog'
// 财务管理结束

import SetMerchant from '_src/pages/merchant/setMerchant'

/* {
    *path: '/路径' 
    exact: exact
    unauthorized: true(不需要权限判断) || 默认false
    *component: 文件路径
    parentPaths : ['父路径'] // 此路由不由菜单进行跳转
} */ 
const routers = [
  {
    path: '/home',
    exact: true,
    component: Home,
  },
  {
    path: '/goods/list',
    exact: true,
    component: GoodList
  },
  {
    path: '/goods/log',
    exact: true,
    component: GoodLog
  },
  {
    path: '/goods/edit',
    exact: false,
    component: EditGoods
  },
  {
    path: '/order/list',
    exact: true,
    component: Order,
  },
  {
    path: '/order/detail',
    component: OrderDetail,
  },
  {
    path: '/discount/list',
    exact: true,
    component: Discount,
  },
  {
    path: '/user/list',
    component: UserList
  },
  {
    path: '/user/detail',
    component: UserDetail,
  },
  {
    path: '/order/returnform',
    component: ReturnForm,
  },
  {
    path: '/order/returnDetail',
    component: ReturnDetail
  },
  {
    path: '/order/refundOrder',
    component: RefundOrder
  },
  {
    path: '/goods/detail',
    component: GoodDetail,
  },
  {
    path: '/system/merchant/list',
    component: MerchantList
  },
  {
    path: '/system/merchant/types',
    component: MerchantType
  }, 
  {
    path: '/system/merchant/add',
    component: AddMerchant
  },
  {
    path: '/system/merchant/detail',
    component: MerchantDetail 
  },

  // 财务统计开始
  {
    path: '/finance/merchants',
    exact: true,
    component: Merchants,
  },
  {
    path: '/finance/recharge',
    exact: true,
    component: Recharge,
  },
  {
    path: '/finance/rechargeLog',
    exact: true,
    component: RechargeLog,
  },
  // 财务统计结束

  // 商户设置哦
  {
    path: '/merchant/setMerchant',
    component: SetMerchant 
  }

]

const initRoutes = [
  {
    path: '/403',
    exact: true,
    component: NoAuthority,
    unauthorized: true
  },
  {
    path: '/404',
    exact: true,
    component: NoFound,
    unauthorized: true
  },
  {
    path: '/500',
    exact: true,
    component: ServerError,
    unauthorized: true
  }
]

export default [...routers, ...initRoutes]